module.exports = __webpack_public_path__ + "static/media/logo-white-no-link.b0fb26c4.png";